module.exports = __webpack_public_path__ + "static/media/app_store@2x.899184b8.png";